module.exports = __webpack_public_path__ + "img/regpack-badge.7f50957f.svg";